import * as React from "react"
const Right = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      stroke="#202327"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.6}
      strokeWidth={1.5}
      d="M5.25 3.5s3.5 2.578 3.5 3.5c0 .922-3.5 3.5-3.5 3.5"
    />
  </svg>
)
export default Right
